<script setup lang="ts">
defineProps<{ productId: number }>();
const { isLoggedIn } = useAccount();
const { siteOptions } = useSiteOptions();
const { result, isSubmitting, onSubmit } = useSubmitReviewForm();
</script>

<template>
  <div class="space-y-4">
    <h3 class="h3 text-primary">
      Écrire un avis
    </h3>
    <div v-if="!isLoggedIn" class="prose">
      <p>
        Vous devez être <a :href="siteOptions.login_url">connecté·e</a> pour écrire un avis.
      </p>
    </div>
    <UiFormWrapper v-else :result="result" @submit="onSubmit">
      <FieldRating name="rating" label="Votre évaluation" required />
      <FieldTextarea name="content" label="Votre avis" required />
      <UiSubmitButton :is-submitting="isSubmitting" />
    </UiFormWrapper>
  </div>
</template>
